import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { I18NextNS } from 'src/models/Language.model';

const useCheckClientVersion = () => {
  const urlParams = new URLSearchParams(window.location.search);
  const platform = urlParams.get('platform');
  const clientVersion = urlParams.get('client');

  const { t } = useTranslation(I18NextNS.PAGES, {
    keyPrefix: 'checkClientVersion',
  });

  useEffect(() => {
    const CLIENT_VERSION = ['1.0.0', '1.0.1', '1.0.2'];

    if (platform && clientVersion) {
      console.log(`Client platform: ${platform} version: ${clientVersion}`);
    }

    if (clientVersion && !CLIENT_VERSION.includes(clientVersion)) {
      console.log(
        `Client version mismatch: current=${clientVersion} required=${CLIENT_VERSION}`,
      );

      window.alert(`
                                                    ⚠️ ${t('title')}

${t('outdatedVersion')}

${t('updatePrompt', { CLIENT_VERSION: CLIENT_VERSION.at(-1) })}

${t('downloadInfo')} https://download.optainhealth.com
      `);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [clientVersion, platform]);
};

export default useCheckClientVersion;
